// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".media-badge--jAc9t{display:flex;align-items:center;margin:0;margin-right:1px;border:0;border-radius:2px;background-color:rgba(36,40,47,.65);padding:5px 7px 4px;color:#fff;font-size:10px;height:22px}.media-badge--jAc9t.clickable--QaMDn{cursor:pointer}.media-badge--jAc9t>i.material-symbols-outlined{font-size:14px;line-height:15px;color:#fff;top:0}.media-badge--jAc9t.smart-search--XDzzt{padding-top:2px;padding-bottom:2px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"media-badge": "media-badge--jAc9t",
	"clickable": "clickable--QaMDn",
	"smart-search": "smart-search--XDzzt"
};
export default ___CSS_LOADER_EXPORT___;
